import React from 'react';
import { TableFooter, TableRow, IconButton, TableCell } from '@material-ui/core';
import { ChevronRight, ChevronLeft } from '@material-ui/icons';

const Pagination = ({ totalPages, page, setPage }) => {
  const handleNextPage = () => {
    if (+page < handleBlockPaginationButton()) {
      setPage(+page + 1);
    }
  };

  const handlePreviousPage = () => {
    if (+page > 0) {
      setPage(+page - 1);
    }
  };

  const handleBlockPaginationButton = () => {
    return +totalPages - 1;
  };

  if (!totalPages) return <></>;

  return (
    <TableFooter>
      <TableRow>
        <TableCell>
          <div className="pagination-container">
            <span data-testid="total-page">
              {+page + 1} of {totalPages}
            </span>
            <div className="pagination-btn">
              <IconButton onClick={handlePreviousPage}>
                <ChevronLeft />
              </IconButton>
              <IconButton onClick={handleNextPage}>
                <ChevronRight />
              </IconButton>
            </div>
          </div>
        </TableCell>
      </TableRow>
    </TableFooter>
  );
};

export default Pagination;
